export class Filtro {
  tipofecha?: string = 'fecha';
  fecha?: string
  fecini?: string;
  fecfin?: string;
  hora?: string;
  horaini?: string;
  horafin?: string;
  id?: string;
  ubigeo?: string;
  idcliente?: number;
  idproveedor?: number
  idvende?: string
  idajuste?: string;
  idliquida?: string
  documen?: string;
  serie?: string;
  numero?: string;
  estado?: string;
  fecemi?: string;
  codigo?: string;
  tarjeta?: string;
  entrega?: string;
  mes?: string;
  idsucursal?: any;
  idproduct?: any;
  isprestamo?: boolean;
  idfactura__idsucursal?: any;
  nombre__icontains?: string;
  incluir_articulos?: boolean;
  tipo_cliente_id?: number[] | number;
  tipo_balon_id?: number[] | number;
  incluir_detalles?:boolean
}

